import React from 'react'
import sidebar from '../../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Boxtitle.png';

function Title({text, width='100%', textColor='black', className=''}) {
  return (
    <div className='h-auto relative' style={{width: width}}>
        <img src={sidebar} alt="Sidebar" className="w-full object-cover h-full" />
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full flex flex-col justify-center items-center px-4 ${className}`} style={{color: textColor}}>{text}</div>
    </div>
  )
}

export default Title